// hooks/usePermissions.js
import { useCallback } from 'react';
import { useUserData } from './useUserData';

export const usePermissions = () => {
  const user = useUserData();

  const canAccessConfiguraciones = () => {
    if (!user?.id_rol) return false;
    const rol = Number(user.id_rol);
    return rol === 1 || rol === 2 || user.es_delegado === true;
  };

  // Función para validar la ruta exclusiva de logística
  const canAccessLogistica = () => {
    if (!user?.id_rol) return false;
    const rol = Number(user.id_rol);
    // Todos pueden entrar a logística, incluyendo el Rol 5
    return true; 
  };

  // Función para bloquear al Rol 5 de áreas comunes (como Clientes)
  const isRestrictedUser = () => {
    return Number(user?.id_rol) === 5;
  };

  return { 
    canAccessConfiguraciones, 
    canAccessLogistica, 
    isRestrictedUser, 
    user 
  };
};